import {
    getISODateTime,
    getMonthDayShort,
    getMonthDayYear,
    getMonthDayYearTime,
    getTime,
    safeFromUnixTime,
    type TimeUnit,
} from '@liveauctioneers/hammer-ui-core/utils/dateTimeFormat';

export { safeFromUnixTime };
export type { TimeUnit };

export const shortFormatDate = (timestamp?: TimeUnit): string =>
    getMonthDayYear(timestamp as TimeUnit, { short: true });

export const longFormatDate = (timestamp?: TimeUnit): string =>
    getMonthDayYearTime(timestamp as TimeUnit, { short: true });

export const shortFormatDateYearless = (timestamp?: TimeUnit): string => getMonthDayShort(timestamp as TimeUnit);

export const timeOnlyDate = (timestamp?: TimeUnit): string => getTime(timestamp as TimeUnit);

export const formatHyphenatedDateOnly = (timestamp?: TimeUnit): string =>
    getISODateTime(timestamp as TimeUnit, { short: true });
